module.exports = __webpack_public_path__ + "static/img/lbx.96c657ad.png";